import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { default as pt } from 'prop-types';
import { connect } from 'react-redux';

import SiteSearchTable from '../components/SiteSearch/SiteSearchTable';
import {
  searchBarInput,
  directToEventDetails,
  directToPortalEventDetails,
} from '../common/modules/siteSearch';
import { loadTemplates } from '../routes/Templates/modules/templateChron';

const ESCAPE_KEY_CODE = 27;

export class SiteSearchContainer extends Component {
  state = {
    popupOpen: false,
  };

  componentDidMount() {
    if (this.props.templates.length < 1) {
      this.props.loadTemplates();
    }
  }

  componentWillReceiveProps(nextProps) {
    // Set the popup to true only when there is a change in the search text
    if (
      nextProps.searchText !== '' &&
      nextProps.searchText !== this.props.searchText
    ) {
      this.setState(() => ({ popupOpen: true }));
    }
  }

  search = (event) => {
    this.props.searchBarInput(event.target.value);
  };

  clearText = () => {
    if (this.props.searchBarInput !== '') {
      this.props.searchBarInput('');
    }
  };

  keyDown = (event) => {
    if (event.keyCode == ESCAPE_KEY_CODE) {
      this.clearText();
    }
  };

  handleCancel = () => {
    this.clearText();
    this.setState(() => ({ popupOpen: false }));
    // Remove the event listener, no need to check for outside clicks once the user clicks on cancel
    document.removeEventListener('click', this.handleOutsideClick, false);
  };

  attachEventListener = () => {
    if (!this.state.popupOpen) {
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
  };

  handleClick = () => {
    // Adding and removing event listener depending on whether the search results are open or not!
    this.attachEventListener();
    // Toggling the state on user click
    this.setState(() => ({ popupOpen: !this.state.popupOpen }));
  };

  handleOutsideClick = (event) => {
    const searchContainerElement = ReactDOM.findDOMNode(this);
    if (searchContainerElement.contains(event.target)) {
      return;
    }
    // disabling focus on the search bar when the user clicks out of the container.
    this.handleClick(event);
  };

  render() {
    return (
      <SiteSearchTable
        directToEventDetails={this.props.directToEventDetails}
        directToPortalEventDetails={this.props.directToPortalEventDetails}
        eventResults={this.props.eventResults}
        templateResults={this.props.templateResults}
        open={this.state.popupOpen}
        search={this.search}
        searchText={this.props.searchText}
        keyDown={this.keyDown}
        handleClick={this.handleClick}
        handleCancel={this.handleCancel}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const allEvents = state.event_chron.events;
  const text = state.site_search.text.toUpperCase();
  const findEvents = allEvents.filter((event) => {
    const eventName = event.eventName
      ? event.eventName.toUpperCase()
      : event.aXSEvent.title.eventTitleText
      ? event.aXSEvent.title.eventTitleText &&
        event.aXSEvent.title.eventTitleText.toUpperCase()
      : event.aXSEvent.title.headliners &&
        event.aXSEvent.title.headliners.toUpperCase();
    const eventLookupId = event.lookupId ? event.lookupId.toUpperCase() : '';
    return text !== ''
      ? eventName.includes(text) || eventLookupId.includes(text)
      : null;
  });

  const findTemplates = state.template_chron.templates.filter((template) => {
    return text !== '' ? template.name.toUpperCase().includes(text) : null;
  });

  return {
    events: state.event_chron.events,
    templates: state.template_chron.templates,
    eventsLoading: state.event_chron.isLoading,
    isLoading: state.site_search.isLoading,
    eventResults: findEvents,
    templateResults: findTemplates,
    searchText: state.site_search.text,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    searchBarInput: (text) => dispatch(searchBarInput(text)),
    directToEventDetails: (eventId) => dispatch(directToEventDetails(eventId)),
    directToPortalEventDetails: (eventId) =>
      dispatch(directToPortalEventDetails(eventId)),
    loadTemplates: () => dispatch(loadTemplates()),
  };
};

SiteSearchContainer.propTypes = {
  searchBarInput: pt.func,
  directToEventDetails: pt.func,
  directToPortalEventDetails: pt.func,
  eventResults: pt.array,
  searchText: pt.string,
  templates: pt.array,
  templateResults: pt.array,
  loadTemplates: pt.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SiteSearchContainer);



// WEBPACK FOOTER //
// ./src/containers/SiteSearchContainer.js